import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface UnitSetDefaultParams {
    readonly id: number;
}

export type UnitSetDefaultResponse = {
    value: number,
    version: string
}[];

export class UnitSetDefaultCommand extends Command<UnitSetDefaultParams, UnitSetDefaultResponse> { }

export class UnitSetDefaultCommandHandlerBase implements CommandHandler<UnitSetDefaultCommand, UnitSetDefaultParams, UnitSetDefaultResponse> {
    private static Url = TaggedUrl.join('products/units/default/:id', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: UnitSetDefaultCommand): Promise<UnitSetDefaultResponse> {
        const { data } = await this.http.put(fillPlaceholders(UnitSetDefaultCommandHandlerBase.Url, { id: command.params?.id }));

        return data;
    }
}
